import { Component, ElementRef, OnInit } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { AnalyticsMetric, StatsService } from 'src/app/services/stats.service';

import { AggregationGroup } from '../../../services/jsonrpc/stats-server.service';
import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-users-widget',
  templateUrl: './users-peak-widget.component.html',
  styleUrls: ['./users-peak-widget.component.scss']
})
export class UsersPeakWidgetComponent extends HomeWidget implements OnInit {
  public count: number = null;

  constructor(elRef: ElementRef, private stats: StatsService) {
    super(elRef);
  }

  ngOnInit() {
    this.stats
      .fetchMetrics(
        AnalyticsMetric.active_users,
        this.settings.relative,
        [AggregationGroup.date],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => {
        this.count = data.reduce((prev, curr) => (curr.users > prev ? curr.users : prev), 0);
      })
      .catch(err => {
        this.count = -1;
        Log.log('UsersPeakWidgetComponent', 'Error', err);
      });
  }
}
